import {
  takeLatest,
  put,
  call,
  select,
  take,
  takeEvery
} from 'redux-saga/effects';
import { push } from 'connected-react-router';

import {
  getSurveyTemplatesIfNeeded,
  getPaginatedSurveyTemplatesIfNeeded,
  getMinimalSurveyTemplatesIfNeeded,
  getTagsIfNeeded,
  getSurveyTemplateIfNeeded,
  createSurveyTemplateFromCurrent,
  updateSurveyTemplateFromCurrent,
  deleteSurveyTemplatesByIdList,
  testSurveyTemplate,
  autoSaveTimerStart
} from './sagas';
import {
  GET_SURVEY_TEMPLATES,
  GET_PAGINATED_SURVEY_TEMPLATES,
  GET_MINIMAL_SURVEY_TEMPLATES,
  GET_SURVEY_TEMPLATE,
  CREATE_SURVEY_TEMPLATE,
  CREATING_SURVEY_TEMPLATE_SUCCEEDED,
  UPDATE_SURVEY_TEMPLATE,
  UPDATING_SURVEY_TEMPLATE_SUCCEEDED,
  DELETE_SURVEY_TEMPLATES,
  CREATING_SURVEY_TEMPLATE_FAILED,
  UPDATING_SURVEY_TEMPLATE_FAILED,
  GETTING_SURVEY_TEMPLATE_FAILED,
  GETTING_SURVEY_TEMPLATES_FAILED,
  DELETING_SURVEY_TEMPLATES_FAILED,
  TEST_SURVEY_TEMPLATE,
  SURVEY_TEMPLATE_AUTO_SAVE_TIMER_START,
  getSurveyTemplates,
  getPaginatedSurveyTemplates,
  GET_SURVEY_TEMPLATE_TAGS,
  DELETING_SURVEY_TEMPLATES_SUCCEEDED
} from './actions';
import { actions as UserActions } from '../user';
import { actions as userMessaging } from '../userMessaging';

/* Helper Sagas */
function* forceGetAllSurveyTemplates(action) {
  yield put(getSurveyTemplates({ force: true }));
  yield put(getPaginatedSurveyTemplates({ force: true }));
  const isInTemplateDesignDialog = yield select(
    store => store.surveyTemplate.isInTemplateDesignDialog
  );
  if (
    action?.type !== 'DELETING_SURVEY_TEMPLATES_SUCCEEDED' &&
    !isInTemplateDesignDialog
  ) {
    const currentSurveyTemplate = yield select(
      store => store.surveyTemplate.current
    );
    if (currentSurveyTemplate.uuid) {
      yield put(
        push(
          `/surveyResultResponse-templates/design/${currentSurveyTemplate.uuid}`
        )
      );
    }
  }
}

function* waitForUserReady() {
  const userReady = yield select(store => store.user.ready);
  if (!userReady) {
    yield take(UserActions.LOGIN_READY);
  }
}

function* HandleFailuresSaga() {
  yield takeLatest(
    [
      CREATING_SURVEY_TEMPLATE_FAILED,
      UPDATING_SURVEY_TEMPLATE_FAILED,
      GETTING_SURVEY_TEMPLATE_FAILED,
      GETTING_SURVEY_TEMPLATES_FAILED,
      DELETING_SURVEY_TEMPLATES_FAILED
    ],
    function*(action) {
      yield put(
        userMessaging.setMessageForFailedAction({
          type: action.type,
          error: action.payload
        })
      );
    }
  );
}

/* APP FLOW - Templates */
function* SurveyTemplateGetManySaga() {
  yield takeLatest(GET_SURVEY_TEMPLATES, function*(action) {
    yield call(waitForUserReady);
    yield call(getSurveyTemplatesIfNeeded, action);
  });
}
function* PaginatedSurveyTemplateGetManySaga() {
  yield takeLatest(GET_PAGINATED_SURVEY_TEMPLATES, function*(action) {
    yield call(waitForUserReady);
    yield call(getPaginatedSurveyTemplatesIfNeeded, action);
  });
}
function* MinimalSurveyTemplateGetManySaga() {
  yield takeLatest(GET_MINIMAL_SURVEY_TEMPLATES, function*(action) {
    yield call(waitForUserReady);
    yield call(getMinimalSurveyTemplatesIfNeeded, action);
  });
}
function* TagGetSaga() {
  yield takeLatest(GET_SURVEY_TEMPLATE_TAGS, function*(action) {
    yield call(getTagsIfNeeded, action);
  });
}
function* SurveyTemplateGetSingleSaga() {
  yield takeLatest(GET_SURVEY_TEMPLATE, function*(action) {
    yield call(waitForUserReady);
    yield call(getSurveyTemplateIfNeeded, action);
  });
}

// brutally refresh to template list on any modification - this *could* be made to act just on the in-memory reducer instead.
function* SurveyTemplateCreateSaga() {
  yield takeLatest(CREATE_SURVEY_TEMPLATE, createSurveyTemplateFromCurrent);
}

function* SurveyTemplateCreateSuccessSaga() {
  yield takeLatest(
    CREATING_SURVEY_TEMPLATE_SUCCEEDED,
    forceGetAllSurveyTemplates
  );
}
function* SurveyTemplateUpdateSaga() {
  yield takeLatest(UPDATE_SURVEY_TEMPLATE, updateSurveyTemplateFromCurrent);
}
function* SurveyTemplateUpdateSuccessSaga() {
  yield takeLatest(
    UPDATING_SURVEY_TEMPLATE_SUCCEEDED,
    forceGetAllSurveyTemplates
  );
}
function* SurveyTemplateDeleteSaga() {
  yield takeLatest(DELETE_SURVEY_TEMPLATES, function*(action) {
    yield call(deleteSurveyTemplatesByIdList, action);
    // yield call(forceGetAllSurveyTemplates); // force refresh even if the delete is unsuccessful - since we don't know if we only partially failed.
  });
}

function* SurveyTemplateDeleteSuccessSaga() {
  yield takeLatest(
    DELETING_SURVEY_TEMPLATES_SUCCEEDED,
    forceGetAllSurveyTemplates
  );
}
function* TestSurveyTemplateSaga() {
  yield takeLatest(TEST_SURVEY_TEMPLATE, testSurveyTemplate);
}

function* AutoSaveTimerSaga() {
  yield takeEvery(SURVEY_TEMPLATE_AUTO_SAVE_TIMER_START, function*(action) {
    yield call(autoSaveTimerStart, action);
  });
}

export default [
  SurveyTemplateGetManySaga,
  PaginatedSurveyTemplateGetManySaga,
  MinimalSurveyTemplateGetManySaga,
  TagGetSaga,
  SurveyTemplateGetSingleSaga,
  SurveyTemplateCreateSaga,
  SurveyTemplateCreateSuccessSaga,
  SurveyTemplateUpdateSaga,
  SurveyTemplateUpdateSuccessSaga,
  SurveyTemplateDeleteSaga,
  SurveyTemplateDeleteSuccessSaga,
  TestSurveyTemplateSaga,
  HandleFailuresSaga,
  AutoSaveTimerSaga
];
